// extracted by mini-css-extract-plugin
export default {"BulkActions":"_BulkActions--dwkpM","Actions":"_Actions--8nL7u","Spacing":"_Spacing--P8z6s"};